module.exports = __webpack_public_path__ + "static/img/CycleBenefactorsClubLogo.f0e15b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CycleBenefactorsClubLogo.png
// module id = 62
// module chunks = 1